import { DateTimeViewer, GetDefaultIndexWithCollect } from "../../components";
import { useGetShareholdersEnterLeaveCommonInfoQuery, useCollectShareholdersEnterLeaveMutation } from "../../features/board/boardSlice";
import { useShareholderEnterLeaveRoutes } from "./routes";
import { ShareholderEnterLeaveCollector } from "./shareholderEnterLeaveCollector";
import { EntityCommonInfoModel } from "../../entities/common";
import { Descriptions } from "antd";

export { useShareholderEnterLeaveRoutes };

export default GetDefaultIndexWithCollect({
  title: "ورود/خروج سهامداران",
  query: useGetShareholdersEnterLeaveCommonInfoQuery,
  collectMutation: useCollectShareholdersEnterLeaveMutation,
  collector: (collectCallback) => <ShareholderEnterLeaveCollector collectCallback={collectCallback} />,
  generalInfoPresentor: (info: EntityCommonInfoModel) =>
    info ? (
      <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}>
        <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
          {info.totalRecords}
        </Descriptions.Item>
        <Descriptions.Item label="آخرین اطلاعات" labelStyle={{ color: "gray" }}>
          <DateTimeViewer value={info.lastCreateAt} mode="date" />
        </Descriptions.Item>
      </Descriptions>
    ) : null,
});
